import React from "react";

const LoginComponentWrapper = ({ children }) => {
  return <div>{children}</div>;
};

export default LoginComponentWrapper;
